import base from '../base/base';
import header from '../base/header';

import storyApp from '../../components/threethings/storyApp';
import threeThingsAPI from '../../components/threethings/factories/threeThingsAPI';
import threeThings from '../../components/threethings/threethings';
import SocialBarLoader from '../../components/SocialBar/SocialBarLoader';
import Viewports from '../../components/fsUtils/Viewports';
import Kixer from '../../components/kixer/Kixer';
import FsLazyLoad from '../../components/fsLazyLoad/FsLazyLoad';

let viewports = new Viewports();
//only start the kixer on mobile device
if(viewports.isMobile) {
    let kixer = new Kixer();
    kixer.initScroll();
}

//fsLazyLoad
let fsLazyLoad = new FsLazyLoad();
fsLazyLoad.init();

new SocialBarLoader();



// WEBPACK FOOTER //
// ./assets/layouts/story/story.js